import BaseModifierBehavior from './BaseModifierBehavior';
import CardStateHelper from '../CardStateHelper';
import { cardsHelper } from '../CardReducer';
import CardsHelper from '../../../Utility/CardsHelper';
import { ICardsState, ValueCardData } from '../ICardState';
import { ICardModifierData } from 'Prototype/Level/Card/ICardModifierData';
import { IGameState } from 'State/Game/IGameState';

export default class RisingModifierBehavior extends BaseModifierBehavior {
    public update(state: ICardsState) {
        const value = (state.cards[this.cardID] as ValueCardData).value;
        const newValue = cardsHelper.draw(value + 1);

        CardStateHelper.updateCard(state, this.cardID, {
            value: newValue,
        });

        return state;
    }
    public onCardMatched(state: IGameState, matchedCardID: string) {
        let cardsState = CardStateHelper.getCardsState(state);
        if (!this.validateUpdate(cardsState)) return state;

        if (matchedCardID === this.cardID) return state;

        const value = (cardsState.cards[this.cardID] as ValueCardData).value;
        const newValue = CardsHelper.instance.draw(value + 1);

        cardsState = CardStateHelper.updateCard(cardsState, this.cardID, {
            value: newValue,
        });

        return CardStateHelper.updateGameState(state, cardsState);
    }

    public onUndoUsed(state: ICardsState, prevCardState: ValueCardData, prevModifier: ICardModifierData) {
        if (!this.validateUpdate(state)) return state;

        const newValue = CardsHelper.instance.draw(prevCardState.value);

        state = CardStateHelper.updateCard(state, this.cardID, {
            value: newValue,
        });

        return state;
    }
}
